import React from 'react';
import Chip from '@mui/material/Chip';
import { Visibility, VisibilityOff, Archive } from '@mui/icons-material';

const GroupTypeChip = ({ type }) => {
    switch (type) {
        case 'public':
            return (
                <Chip
                    size="small"
                    icon={<Visibility fontSize="small" />}
                    label="Public Group"
                    variant="outlined"
                />
            );
        case 'archive':
            return (
                <Chip
                    size="small"
                    icon={<Archive fontSize="small" />}
                    label="Archive Group"
                    variant="outlined"
                />
            );
        default:
            return (
                <Chip
                    size="small"
                    icon={<VisibilityOff fontSize="small" />}
                    label="Private Group"
                    variant="outlined"
                />
            );
    }
};

export default GroupTypeChip;